(function(){
  function initCarousel(trackId, prevId, nextId) {
    var t = document.getElementById(trackId);
    if (!t) return;
    function cw() {
      var c = t.querySelector('[class*="-card"]');
      return c ? c.offsetWidth + 16 : 300;
    }
    var prev = document.getElementById(prevId);
    var next = document.getElementById(nextId);
    if (prev) prev.addEventListener('click', function(){ t.scrollBy({left:-cw(),behavior:'smooth'}); });
    if (next) next.addEventListener('click', function(){ t.scrollBy({left:cw(),behavior:'smooth'}); });
  }
  document.addEventListener('DOMContentLoaded', function(){
    initCarousel('hpProbTrack','hpProbPrev','hpProbNext');
    initCarousel('hpFeatTrack','hpFeatPrev','hpFeatNext');
  });
})();
